import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout/Layout';
import OfflineStatus from './components/OfflineStatus/OfflineStatus';
import Home from './pages/Home/Home';
import SlangTranslator from './pages/SlangTranslator/SlangTranslator';
import { register } from './utils/serviceWorker';

function App() {
  useEffect(() => {
    // Register service worker for offline functionality
    register({
      onSuccess: () => {
        console.log('Service Worker: Registered successfully');
      },
      onUpdate: () => {
        console.log('Service Worker: New content available');
        // Could show a notification to user about update
      },
      onOffline: () => {
        console.log('App: Offline mode activated');
      },
      onOnline: () => {
        console.log('App: Online mode restored');
      }
    });
  }, []);

  return (
    <Router>
      <div className="App">
        <OfflineStatus />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/translate" element={<SlangTranslator />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;
